import { Autocomplete, AutocompleteChangeDetails, Chip, TextField, createFilterOptions } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import './TagFilter.scss'
import { QueryItem } from '../Tonnage/models/TonnageQueryModel';
import { AutoCompleteFilterOptionState } from '../Tonnage/components/TonnageNameSelector';

interface TagFilterProps {
    data: QueryItem[],
    label: string,
    value: QueryItem[],
    className?: string,
    useFreeText?: boolean,
    triggerFocusInput?: number,
    hideReverseButton?: boolean,
    filterLimit?: number,
    onValueChange?: (value: QueryItem[]) => void,
    onInputChange?: (value: string) => void,
}

const TagsFilter: React.FunctionComponent<TagFilterProps> = (props) => {
    const dispatch = useDispatch();
    const [selectedValues, setSelectedValues] = useState<QueryItem[]>([]);
    const filterLimit = 10;

    const textboxRef = React.createRef<HTMLInputElement>();

    useEffect(() => {
        setSelectedValues(props.value);
    }, [props.value])

    useEffect(() => {
        if (props.triggerFocusInput && props.triggerFocusInput > 0) {
            textboxRef.current?.focus();
        }
    }, [props.triggerFocusInput])

    return (
        <>
            <Autocomplete
                multiple
                freeSolo={props.useFreeText === true ? true : false}
                options={props.data}
                value={selectedValues}
                className={props.className ? props.className : ""}
                renderInput={(params) => <TextField autoFocus {...params} label={props.label} inputRef={textboxRef} />}
                renderTags={(value: readonly QueryItem[], getTagProps) => {
                    return value.map((option: QueryItem, index: number) => {
                        let isPositive = option.positive === undefined || option.positive === true;
                        let className = isPositive ? "tag-filter-positive" : "tag-filter-negative";

                        return <span className={"tag-filter " + className} >
                            {
                                props.hideReverseButton !== true &&
                                <i className="fa fa-refresh" aria-hidden="true"
                                    onClick={() => {
                                        let items = [...selectedValues];
                                        items[index] = {
                                            ...items[index],
                                            positive: !isPositive
                                        }
                                        setSelectedValues(items);

                                        if (props.onValueChange) {
                                            props.onValueChange(items);
                                        }
                                    }} ></i>
                            } &nbsp;
                            {option.value}
                            &nbsp;
                            <i className="fa fa-times" aria-hidden="true"
                                onClick={() => {
                                    let items = [...selectedValues];
                                    items.splice(index, 1);
                                    setSelectedValues(items);

                                    if (props.onValueChange) {
                                        props.onValueChange(items);
                                    }
                                }}
                            ></i>
                        </span>
                    })
                }}
                filterOptions={(options: Array<QueryItem>, state: AutoCompleteFilterOptionState) => {
                    let inputValue = state.inputValue;

                    let searchResults = options.filter((option) => option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
                    let searchResultsExcludeSelectedValue = _.filter(searchResults, (option) => {
                        return _.findIndex(props.value, (value) => {
                            return option.value.toLowerCase() === value.value.toLowerCase();
                        }) < 0;
                    });

                    return _.take(searchResultsExcludeSelectedValue, props.filterLimit ? props.filterLimit : filterLimit);
                }}
                getOptionLabel={(option: QueryItem) => {
                    return option.value;
                }}
                onChange={(event: React.SyntheticEvent, values: Array<QueryItem | string>, reason: string, details?: AutocompleteChangeDetails<QueryItem>) => {
                    let tagValues = _.map(values, (value) => {
                        return typeof value === "string" ? {
                            id: value,
                            value: value.toUpperCase(),
                            positive: true
                        } as QueryItem : value as QueryItem;
                    });

                    setSelectedValues(tagValues);

                    if (props.onValueChange) {
                        props.onValueChange(tagValues);
                    }
                }}
                onInputChange={(event: React.SyntheticEvent, value: string, reason: string) => {
                    if (props.onInputChange) {
                        props.onInputChange(value);
                    }
                }}
            />
        </>
    )
};

export default TagsFilter;